import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-vh-100 d-flex align-items-center bg-light" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-md-6 col-lg-5" }
const _hoisted_5 = { class: "card border-0 shadow-lg" }
const _hoisted_6 = { class: "card-body p-5" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4",
  role: "alert"
}
const _hoisted_8 = {
  key: 1,
  class: "alert alert-danger d-flex align-items-center mb-4",
  role: "alert"
}
const _hoisted_9 = {
  key: 2,
  class: "alert alert-warning d-flex align-items-center mb-4",
  role: "alert"
}
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "form-floating mb-3" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-floating mb-3 position-relative" }
const _hoisted_14 = ["type"]
const _hoisted_15 = { class: "material-symbols-outlined" }
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_17 = { class: "form-floating mb-4 position-relative" }
const _hoisted_18 = ["type"]
const _hoisted_19 = { class: "material-symbols-outlined" }
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_21 = { class: "d-grid mb-4" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_24 = {
  key: 4,
  class: "text-center"
}
const _hoisted_25 = {
  key: 5,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-center mb-4" }, [
                _createElementVNode("h2", { class: "fw-bold text-primary mb-2" }, "Reimposta Password"),
                _createElementVNode("p", { class: "text-muted" }, " Inserisci la tua nuova password per completare il reset. ")
              ], -1)),
              _createElementVNode("form", {
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)), ["prevent"]))
              }, [
                (_ctx.successMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "check_circle", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.successMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.apiError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "error", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.apiError), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tokenError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _cache[11] || (_cache[11] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "warning", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.tokenError), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.resetCompleted && !_ctx.tokenError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("input", {
                          type: "email",
                          class: "form-control",
                          id: "resetEmail",
                          value: _ctx.email,
                          disabled: ""
                        }, null, 8, _hoisted_12),
                        _cache[12] || (_cache[12] = _createElementVNode("label", { for: "resetEmail" }, "Email", -1))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.passwordFieldType,
                          class: _normalizeClass(["form-control", { 'is-invalid': _ctx.passwordError }]),
                          id: "newPassword",
                          placeholder: "Nuova password",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validatePassword && _ctx.validatePassword(...args))),
                          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validatePassword && _ctx.validatePassword(...args))),
                          required: ""
                        }, null, 42, _hoisted_14), [
                          [_vModelDynamic, _ctx.password]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("label", { for: "newPassword" }, "Nuova Password", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn border-0 position-absolute top-50 end-0 translate-middle-y d-flex align-items-center justify-content-center",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args))),
                          style: {"z-index":"10"}
                        }, [
                          _createElementVNode("i", _hoisted_15, _toDisplayString(_ctx.isPasswordVisible ? 'visibility_off' : 'visibility'), 1)
                        ]),
                        (_ctx.passwordError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.passwordError), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.confirmPasswordFieldType,
                          class: _normalizeClass(["form-control", { 'is-invalid': _ctx.confirmPasswordError }]),
                          id: "confirmPassword",
                          placeholder: "Conferma password",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validatePasswordConfirmation && _ctx.validatePasswordConfirmation(...args))),
                          onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validatePasswordConfirmation && _ctx.validatePasswordConfirmation(...args))),
                          required: ""
                        }, null, 42, _hoisted_18), [
                          [_vModelDynamic, _ctx.passwordConfirmation]
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("label", { for: "confirmPassword" }, "Conferma Password", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn border-0 position-absolute top-50 end-0 translate-middle-y d-flex align-items-center justify-content-center",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleConfirmPasswordVisibility && _ctx.toggleConfirmPasswordVisibility(...args))),
                          style: {"z-index":"10"}
                        }, [
                          _createElementVNode("i", _hoisted_19, _toDisplayString(_ctx.isConfirmPasswordVisible ? 'visibility_off' : 'visibility'), 1)
                        ]),
                        (_ctx.confirmPasswordError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.confirmPasswordError), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-primary btn-lg",
                          disabled: !_ctx.isFormValid || _ctx.isLoading
                        }, [
                          (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? 'Resettando...' : 'Reimposta Password'), 1)
                        ], 8, _hoisted_22)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.resetCompleted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("p", { class: "text-muted mb-4" }, " La tua password è stata cambiata con successo. Torna alla pagina precedente per continuare il login. ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_ctx.tokenError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mb-4" }, [
                        _createElementVNode("i", {
                          class: "material-symbols-outlined text-warning",
                          style: {"font-size":"4rem"}
                        }, "error")
                      ], -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-muted mb-4" }, " Il link non è valido o è scaduto. Richiedi un nuovo reset password. ", -1)),
                      _createVNode(_component_RouterLink, {
                        to: "/authentication/login",
                        class: "btn btn-primary"
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode(" Torna al Login ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 32)
            ])
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-center mt-4" }, null, -1))
        ])
      ])
    ])
  ]))
}